import { render, staticRenderFns } from "./dangerousChemicals.vue?vue&type=template&id=49029d68&scoped=true"
import script from "./dangerousChemicals.vue?vue&type=script&lang=js"
export * from "./dangerousChemicals.vue?vue&type=script&lang=js"
import style0 from "./dangerousChemicals.vue?vue&type=style&index=0&id=49029d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49029d68",
  null
  
)

export default component.exports